export default function parseFormTags(value) {
    const arrTags = value.split(",")
    const fixedTags = arrTags.map(tag => tag && tag.toLowerCase().trim()).filter(delEmpty => delEmpty)
    return fixedTags
}